const BranchMap = (branchCode) => {
  switch (branchCode) {
    case "BEIS":
      return  "Information Science and Engineering" ;
    default:
      return  "Unkown Branch" ;
  }
};

export default BranchMap;
